import { useSelector } from 'react-redux';
import { getThemeKey } from 'themes/themesSelectors';
import useSystemColorScheme from './useSystemColorScheme';

const useThemeMode = () => {
  const themeKey = useSelector(getThemeKey);
  const systemColorScheme = useSystemColorScheme();
  if (themeKey === 'system-appearance') return systemColorScheme;
  return themeKey === 'ACME_DARK' ? 'dark' : 'light';
};

export default useThemeMode;
